var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LanguageSelect"},[_c('Dropdown',{attrs:{"options":_vm.dropdownOptions,"initialValue":_vm.value},on:{"input":function($event){_vm.value = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }